var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement } from 'react';
import cn from 'classnames';
import styles from 'core-components/src/components/typography/typography.scss';
const Typography = (_a) => {
    var { color, size, unit, align, light, bold, component, children, className, style } = _a, props = __rest(_a, ["color", "size", "unit", "align", "light", "bold", "component", "children", "className", "style"]);
    const css = cn({
        [styles.typography]: true,
        [styles[align]]: align,
        [styles.light]: light,
        [styles.bold]: bold,
        [className]: className
    });
    return cloneElement(component, Object.assign(Object.assign({}, props), { className: css, style: Object.assign({ color, fontSize: size ? `${size}${unit}` : '' }, style), children }));
};
Typography.defaultProps = {
    size: 16,
    unit: 'px',
    color: '#444',
    align: 'left',
    bold: false,
    light: false,
    component: React.createElement("p", null)
};
export { Typography };
